module.exports = __webpack_public_path__ + "img/IL.7bbb3eec.svg";